import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Obfuscate from 'react-obfuscate';

// mock --> replace by implementation of permission check based on user roles and person context
const checkPermission = (perm, context) => {
  return true;
};

const PersonContact = (props) => {
  const { content, metadata } = props;
  const personData = metadata || content || {};
  const hidden = personData?.hidden_fields || [];
  const user_logged_in = useSelector((state) => state.userSession?.token);
  const canModify = user_logged_in
    ? checkPermission('Modify portal content', personData)
    : false;
  const person_context = personData?.aq_parent || {};
  const hide_details_on_alumni = person_context?.hide_details_on_alumni || true;
  const alumni = personData?.former;
  const visContact =
    (((!hide_details_on_alumni || !alumni) &&
      !hidden.map((a) => a.token).includes('official')) ||
      canModify) &&
    (personData?.contact_address ||
      personData?.contact_zip ||
      personData?.contact_city ||
      personData?.contact_email ||
      personData?.contact_phone ||
      personData?.contact_fax ||
      personData?.contact_mobile);
  const visPrivate =
    (((!hide_details_on_alumni || !alumni) &&
      !hidden.map((a) => a.token).includes('private')) ||
      canModify) &&
    (personData?.private_address ||
      personData?.private_zip ||
      personData?.private_city ||
      personData?.private_email ||
      personData?.private_phone ||
      personData?.private_fax ||
      personData?.private_mobile);
  const someContact = visContact || visPrivate;

  const renderAddress = (prefix) => {
    const address = personData[`${prefix}_address`];
    const zip = personData[`${prefix}_zip`];
    const city = personData[`${prefix}_city`];
    const country = personData[`${prefix}_country`];
    if (!address && !zip && !city) return null;
    const addressLines = address ? address.split('\n') : [];
    return (
      <span className={`person-${prefix}-address`}>
        {addressLines.map((line, i) => (
          <span key={i}>{line.trim()}</span>
        ))}{' '}
        {country && zip && city && (
          <span>
            {zip} {city}
          </span>
        )}
      </span>
    );
  };

  const renderContactBlock = (prefix, label) => {
    const isHidden =
      (hidden
        .map((a) => a.token)
        .includes(prefix === 'contact' ? 'official' : prefix) ||
        (hide_details_on_alumni && alumni && prefix === 'contact')) &&
      canModify;
    const className = isHidden ? 'address state-private' : 'address';
    return (
      <div className={className}>
        {personData[`${prefix}_email`] && (
          <div className={`person-${prefix}-email`}>
            <Obfuscate email={personData[`${prefix}_email`]}></Obfuscate>
          </div>
        )}
        {personData[`${prefix}_phone`] && (
          <div className={`person-${prefix}-phone`}>
            <span className="person-detail-label">
              <FormattedMessage
                id="persons.contact.phone"
                defaultMessage="Tel."
              />
              :{' '}
            </span>
            <span>{personData[`${prefix}_phone`]}</span>
          </div>
        )}
        {personData[`${prefix}_fax`] && (
          <div className={`person-${prefix}-fax`}>
            <span className="person-detail-label">
              <FormattedMessage id="persons.contact.fax" defaultMessage="Fax" />
              :{' '}
            </span>
            <span>{personData[`${prefix}_fax`]}</span>
          </div>
        )}
        {personData[`${prefix}_mobile`] && (
          <div className={`person-${prefix}-mobile`}>
            <span className="person-detail-label">
              <FormattedMessage
                id="persons.contact.phonemobile"
                defaultMessage="Mobil"
              />
              :{' '}
            </span>
            <span>{personData[`${prefix}_mobile`]}</span>
          </div>
        )}
        <address>{renderAddress(prefix)}</address>
      </div>
    );
  };

  return (
    <>
      {someContact && (
        <div className="person-contact-wrapper">
          <h2>
            <FormattedMessage
              id="persons.contact"
              defaultMessage="Kontaktinformationen"
            />
          </h2>
          <div className="contact-details">
            {visContact && renderContactBlock('contact', 'Official')}
            {visPrivate && renderContactBlock('private', 'Private')}
          </div>
        </div>
      )}
    </>
  );
};

export default PersonContact;
